import httpService from "@/utils/request";
import { message } from "ant-design-vue";

const smsMessageService = {
    
    getSmsMessagePageListByParams:(param:any)=>{
        const url = "/business/smsMessageType/getSmsMessagePageListByParams";
        return httpService.post(url,param);
    },

    removeSmsMessageById:(id:any)=> {
        const url = "/business/smsMessageType/deleteSmsMessage/"+id;
        return httpService.delete(url);
    },

    createSmsMessage:(item:any)=>{
        const url = "/business/smsMessageType/createSmsMessage";
        return httpService.post(url,item);
    },

    saveSmsMessage:(item:any)=>{
        const url = "/business/smsMessageType/updateSmsMessage";
        return httpService.put(url,item);
    },

    batchDeleteSmsMessage:(item:any)=>{
        const url = "/business/smsMessageType/batchDeleteSmsMessage?messageIds="+item;
        return httpService.delete(url);
    },

    getMessageById(id:any){
        const url = "/business/smsMessageType/getSmsMessage/"+id;
        return httpService.get(url);
    },

    resendMessage:(item:any)=>{
        const url = "/business/smsMessageType/resendMessage?messageId="+item;
        return httpService.get(url);
    },

    getIndicatorList:(scopeId:any)=>{
        const url = "/business/smsMessageType/getIndicatorList?scopeId="+scopeId;
        return httpService.get(url);
    },

    createSmsMessageAndPush:(item:any)=>{
        const url = "/business/smsMessageType/createSmsMessageAndPush";
        return httpService.post(url,item);
    },

    getSmsMessageTypePageListByParams:(param:any)=>{
        const url = "/business/smsMessageType/getSmsMessageTypePageListByParams";
        return httpService.post(url,param);
    },

    getSmsMessageTypeByScopeId:(scopeId:any)=>{
        const url = "/business/smsMessageType/getSmsMessageTypeByScopeId?scopeId="+scopeId;
        return httpService.get(url);
    },

    removeSmsMessageTypeById(id:any){
        const url = "/business/smsMessageType/deleteSmsMessageType/"+id;
        return httpService.delete(url);
    },

    updateSmsMessageType:(item:any)=>{
        const url = "/business/smsMessageType/updateSmsMessageType";
        return httpService.put(url,item);
    },

    createSmsMessageType(item:any){
        const url = "/business/smsMessageType/createSmsMessageType";
        return httpService.post(url,item);
    },

    getSmsMessageTypeCountByScopeId:(scopeId:any)=>{
        const url = "/business/smsMessageType/getSmsMessageTypeCountByScopeId?scopeId="+scopeId;
        return httpService.get(url);
    },

    batchDeleteSmsMessageType(ids:any){
        const url = "/business/smsMessageType/batchDeleteSmsMessageType?typeIds="+ids;
        return httpService.delete(url);
    },

    getPageMessageRecordByParams(params:any){
        const url = "/business/smsMessageType/getOpeSmsPageListByParams";
        return httpService.post(url,params);
    },
    
    getStaffListByMessageId(messageId:any){
        const url = "/business/smsMessageType/getStaffListByMessageId?messageId="+messageId;
        return httpService.get(url);
    },

    getSmsMessageIndicatorTitleDtoByParams(params:any){
        const url = "/business/smsMessageType/getSmsMessageIndicatorTitleDtoByParams";
        return httpService.post(url,params);
    },

    getSmsMessageTypeIndicatorTitleDtoByParams(params:any){
        const url = "/business/smsMessageType/getSmsMessageTypeIndicatorTitleDtoByParams";
        return httpService.post(url,params);
    },


}
export default smsMessageService;
